// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 962 ? "QQShare" : chunkId) + "." + {"388":"9bec80330e","962":"b45f7e33d7"}[chunkId] + ".js";
};